import { useEffect, useState } from 'react'
import { Room } from '@ably/chat'

export function useTypingIndicator(room: Room | null) {
  const [typingUsers, setTypingUsers] = useState<string[]>([])

  useEffect(() => {
    if (!room) return

    const { unsubscribe } = room.typing.subscribe((event) => {
      setTypingUsers(event.currentlyTyping.map(u => u.clientId))
    })

    return () => {
      unsubscribe()
    }
  }, [room])

  const startTyping = async () => {
    if (room) {
      await room.typing.start()
    }
  }

  const stopTyping = async () => {
    if (room) {
      await room.typing.stop()
    }
  }

  return {
    typingUsers,
    isTyping: typingUsers.length > 0,
    startTyping,
    stopTyping
  }
}
